import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import ContentError from './ContentError';
import MarkdownContent from './MarkdownContent';
import HtmlContent from './HtmlContent';
import WhiteboardContent from './WhiteboardContent';
import BookmarkContent from './BookmarkContent';
import ReactContent from './ReactContent';
import MultiFileReactContent from './MultiFileReactContent';
import AskMultipleChoiceContent from './AskMultipleChoiceContent';

export interface MessageProps {
  body: string;
  contentType?: string;
  toolCallId?: string;
  approveAction?: (data?: Record<string, unknown>) => void;
  rejectAction?: () => void;
  contentAction?: () => void;
  toolCallData?: string;
}

const AhaHtmlContent = ApplicationView(({ body }: MessageProps) => {
  return (
    <div
      // AhaHtml content was generated by Ruby and is safe to use as-is.
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
});

// Display the content of a message according to its mime type, also processing
// with markdown.
const MessageContent = (props: MessageProps) => {
  const {
    body,
    contentType = 'text/markdown',
    contentAction,
    toolCallData,
  } = props;

  let content: React.ReactNode;
  switch (contentType) {
    case 'text/plain': // We treat plain text as markdown since ... why not.
    case 'text/markdown':
      content = <MarkdownContent body={body} />;
      break;

    case 'text/html':
      content = <HtmlContent body={body} />;
      break;

    case 'application/vnd.aha.react':
      content = (
        <ReactContent files={{ 'App.tsx': body }} contentType={contentType} />
      );
      break;

    case 'application/vnd.aha.react_entrypoint':
      content = (
        <MultiFileReactContent body={body} toolCallData={toolCallData} />
      );
      break;

    case 'application/vnd.aha.html':
      content = <AhaHtmlContent body={body} />;
      break;

    case 'application/vnd.aha.whiteboard':
      content = <WhiteboardContent body={body} />;
      break;

    case 'application/vnd.aha.bookmark':
      content = <BookmarkContent body={body} />;
      break;

    case 'application/vnd.aha.askMultipleChoice':
      content = <AskMultipleChoiceContent {...props} />;
      break;

    case 'application/vnd.aha.image':
      return <img src={body} />;

    default:
      content = <ContentError message='Unhandled content type ' />;
  }

  if (contentAction) {
    return (
      <div onClick={contentAction} className='tw-cursor-pointer'>
        {content}
      </div>
    );
  } else {
    return content;
  }
};

export default ApplicationView(MessageContent);
